import { render, staticRenderFns } from "./NormEdit.vue?vue&type=template&id=57b9efe8"
import script from "./NormEdit.vue?vue&type=script&lang=js"
export * from "./NormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports